var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoteUpCast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 19.5,
    height: 17.5,
    viewBox: "0 0 19.5 17.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147224802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M9.31364 0.617726L1.93699 7.25671C1.25578 7.8698 1.68947 9 2.60596 9H6C6.55228 9 7 9.44771 7 10V16.5C7 17.0523 7.44772 17.5 8 17.5H12C12.5523 17.5 13 17.0523 13 16.5V10C13 9.44771 13.4477 9 14 9H16.9904C17.8944 9 18.3344 7.89576 17.6782 7.27405L10.6703 0.635067C10.2918 0.276444 9.70123 0.268895 9.31364 0.617726Z",
    fill: "#1A478B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteUpCast);
export default __webpack_public_path__ + "static/media/vote-up-cast.3c33866e7e9bd3ec6703cacd9ab8212d.svg";
export { ForwardRef as ReactComponent };